import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';

const CarSingle = () => {
  const { id } = useParams();
  
  useEffect(() => {
    document.title = 'NEST | Car Details';
  }, []);
  
  return (
    <div>
      <HeroBanner 
        title="Car Details" 
        breadcrumbs={['Our Car', 'Details']}
      />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-7 heading-section text-center ftco-animate">
              <h2>Car Details {id}</h2>
              <p>Content coming soon.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CarSingle;


